import {get, set} from "lodash/object";
import getDataSchema from "../getDataSchema";
import {getDMMF} from "@prisma/sdk";
import {difference, fromPairs, intersection} from "lodash/array";
import {crud} from "../transform";

const extractType = type => type.type?.type?.type || type.type?.type || type.type || type;

// TODO add recursive remapping for nested translated types
export default function translate(fields) {
    fields = Array.isArray(fields) ? fields : [fields];
    return async ({typeDefs, resolvers}) => {
        await Promise.all(fields.map(async f => {
            let path = f.split('.');
            if (path.length < 2) {
                path.unshift('Query')
            }
            // basic data
            const typeIndex = typeDefs.definitions.findIndex(d => d.name?.value === path[0]);
            const fieldIndex = typeDefs.definitions[typeIndex].fields.findIndex(f => f.name?.value === path[1]);
            const fieldType = extractType(typeDefs.definitions[typeIndex].fields[fieldIndex].type);
            const fieldTypeDef = typeDefs.definitions.find(t => t.name?.value === fieldType.name.value);

            // determine if translated type already defined, if not - create and add type definition
            let translatedTypeDef = typeDefs.definitions.find(t => t.name?.value === fieldType.name.value + 'Translated');
            if (!translatedTypeDef) {
                // using datamodel is the only way to determine which field is bound to relation
                const datamodel = await getDMMF({datamodel: await getDataSchema()});
                const model = datamodel.datamodel.models.find(m => m.name === fieldType.name.value + 'Translation');
                const translationTypeDef = typeDefs.definitions.find(t => t.name?.value === fieldType.name.value + 'Translation');
                translatedTypeDef = JSON.parse(JSON.stringify(fieldTypeDef));
                translatedTypeDef.name.value = fieldTypeDef.name.value + 'Translated';
                translatedTypeDef.fields = [
                    ...fieldTypeDef.fields.filter(({name: {value}}) => value !== 'translations'),
                    ...translationTypeDef.fields
                        // remove fields that present in parent type
                        .filter(({name}) => !fieldTypeDef.fields.find(f => f.name?.value === name.value))
                        // remove relation fields (e.g. userId) - it is isReadOnly
                        .filter(({name}) => !model.fields.find(f => f.name === name.value && f.isReadOnly))
                        // remove relation
                        .filter(({type}) => extractType(type).name?.value !== fieldType.name.value)
                ]
                typeDefs.definitions.push(translatedTypeDef);
            }

            // create and add translated field
            // TODO could be done with extend type... decide when implementing recursion
            const translatedField = JSON.parse(JSON.stringify(typeDefs.definitions[typeIndex].fields[fieldIndex]));
            translatedField.name.value = translatedField.name.value + 'Translated';
            extractType(translatedField.type).name.value = fieldType.name.value + 'Translated';
            typeDefs.definitions[typeIndex].fields.push(translatedField);

            // fetch resolver — user-provided or default from crud
            const resolver = get(resolvers, f, get(crud().resolvers, path.join('.')));

            // wrap the resolver to transform selection and result
            set(resolvers, f + 'Translated', async (p, args, c, i) => {
                const fieldNames = fieldTypeDef.fields.map(({name: {value}}) => value);
                const typeFields = intersection(Object.keys(args.select), fieldNames);
                const translationFields = difference(Object.keys(args.select), fieldNames);
                if (translationFields.length) {
                    args.select = {
                        ...fromPairs(typeFields.map(f => [f, args.select[f]])),
                        translations: {
                            where: {lang: {equals: c.locale}},
                            select: fromPairs(translationFields.map(f => [f, args.select[f]]))
                        }
                    }
                }
                const result = await resolver(p, args, c, i);
                const remap = {
                    ...result,
                    ...result.translations[0]
                }
                delete remap.translations;
                return remap;
            })
        }))
        return {typeDefs, resolvers};
    }
}
